<template>
  <div class="board-mini" :class="{ favorite: isFavorite }" @click="$emit('click')">
    <v-layout row wrap>
      <v-flex xs12 class="board-name">{{ board.name }}</v-flex>
      <v-flex xs6 class="pa-0">
        <v-icon class="left ml-2 board-favorite" @click="toggleFavorite()" @click.stop="">{{ getIcon() }}</v-icon>
      </v-flex>
      <v-flex v-if="toolbar" xs6 class="board-toolbar pa-0 pr-1">
        <v-menu>
          <template v-slot:activator="{ on }">
            <v-btn @click.stop="on.click" small icon class="right" style="margin: 0;">
              <v-icon class="mx-0" color="purple lighten-5">more_horiz</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-tile
              v-for="(item, index) in boardMenu"
              :key="index"
              @click="boardMenuHandler( item.action )"
            >
              <v-icon class="mr-3">{{ item.icon }}</v-icon>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
    </v-layout>
  </div>
</template>

<style>

  .board-mini {
    background-color: #907fa5;
    border-radius: 4px;
    color: #eee;
    cursor: pointer;
    font-size: 16px;
    min-height: 100px;
    padding: 10px;
    text-transform: none;
    width: 100%;
  }

  .board-mini .board-name {
    height: 68px;
  }

  .board-mini:hover {
    background-color: #9f8eb4;
  }

  .board-mini .board-toolbar {
    height: 28px;
  }

  .board-mini .board-favorite {
    font-size: 20px;
    color: #db4 !important;
    opacity: 0;
    transition: opacity 0.5s;
  }

  .board-mini:hover .board-favorite, .board-mini.favorite .board-favorite {
    opacity: 1;
    /*transition: opacity 1s;*/
  }

  .board-mini .board-favorite:hover {
    color: #eee;
    /*opacity: 1;*/
    /*transition: opacity 1s;*/
  }

</style>

<script>

  /**
   *
   *
   */
  export default {

    name: 'BoardMini',

    /**
     * Входные данные.
     *
     */
    props: {

      // Доска.
      board: {
        type: Object,
        required: true
      },

      // Режим редактирования.
      toolbar: {
        type: Boolean,
        required: false,
        default: false
      },

      // Статус избранного.
      favorite: {
        type: Boolean,
        required: false,
        default: true
      }
    },

    /**
     * Операционные данные компонента.
     *
     */
    data() {

      return {

        // Меню управления доской.
        boardMenu: [
          { icon: 'mdi-account-plus-outline', title: 'Открыть доступ', action: 'share' },
          { icon: 'edit', title: 'Редактировать доску', action: 'edit' },
          { icon: 'delete', title: 'Удалить доску', action: 'delete' },
        ],

        // Статус избранного.
        isFavorite: false
      }
    },

    /**
     * Инициализация входных системных данных.
     *
     */
    watch: {

      /**
       * Статус избранного.
       *
       */
      board: {

        handler( board ) {

          this.isFavorite = board.favorite
        },

        // Необходимо для инициализации значения по умолчанию
        immediate: true,

        // Необходимо для отслеживания всех свойств объекта на всю глубину
        deep: true
      }
    },

    /**
     *
     *
     */
    computed: {

    },

    /**
     *
     *
     */
    methods: {

      /**
       *
       *
       */
      init() {

      },

      /**
       * Обработчик действия над доской.
       *
       * @param action
       */
      boardMenuHandler( action ) {

        if ( action === 'share' ) {
          this.$emit( action, this.board )
        }
        else if ( action === 'edit' ) {
          this.$emit( action, this.board )
        }
        else if ( action === 'delete' ) {
          this.$emit( action, this.board )
        }
      },

      // /**
      //  *
      //  *
      //  */
      // isFavorite() {
      //   return this.favorite && this.board.favorite
      // },

      /**
       * Переключение статуса избранного в противоположное состояние.
       *
       */
      toggleFavorite() {

        let board = Object.assign( {}, this.board )

        this.isFavorite = !this.isFavorite
        board.favorite = this.isFavorite
        this.$emit( 'favorite', board, this.isFavorite )
      },

      /**
       * Получение иконки.
       *
       * @returns {string}
       */
      getIcon() {
        return this.isFavorite ? 'star' : 'star_border'
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/apps/bpm/kanban/components/BoardMini.vue